import React, { useRef, ReactElement } from 'react';
import classNames from 'classnames';

import { useStepEditorContext } from 'src/store/step-editor';
import { StepEditorPreviewNavigator } from './navigator';
import { StepEditorPreviewDeviceToggles } from './device-toggles';

import { PreviewRenderer } from 'src/dashboard/JourneyEditorPreview';
import { useContentPreviewGenerator } from 'src/editor/use-content-preview-generator.hook';
import EditorContentFormDevicePreview from 'src/editor/content-form/device-preview';
import { Nullable } from 'src/types/nullable.type';
import { EditorHeader } from 'src/editor/components/header';

interface StepEditorPreviewPanelProps {
  isEditingJourney?: boolean;
  actionButton?: Nullable<ReactElement>;
}

export const StepEditorPreviewPanel = ({ isEditingJourney, actionButton }: StepEditorPreviewPanelProps) => {
  const previewRef = useRef(null);
  const { renderContentPreview } = useContentPreviewGenerator();
  const { isMobilePreview } = useStepEditorContext();
  const nodePreviewRef = useRef<Nullable<HTMLDivElement>>(null);

  return (
    <PreviewRenderer>
      {({ preview }) => (
        <div className='flex flex-1 flex-col p-0 relative w-[calc(100vh-368px)] h-full min-w-0 px-lg py-lg bg-bedrock-light-gray ml-[368px]'>
          {!isEditingJourney ? <StepEditorPreviewDeviceToggles /> : <EditorHeader />}
          <div
            className={classNames(
              'flex flex-1 flex-col bg-white w-full h-full min-w-0 px-lg pt-lg pb-lg rounded-lg',
              !isEditingJourney ? 'mt-8' : 'mt-md'
            )}
          >
            <div className='flex flex-grow min-h-0 min-w-0 relative' ref={previewRef}>
              {preview && isMobilePreview ? (
                <div className='flex flex-col flex-1 h-full relative m-0'>
                  <div className='absolute inset-0' ref={nodePreviewRef}>
                    <EditorContentFormDevicePreview
                      preview={<div className='absolute inset-4'>{preview}</div>}
                      isMobile={true}
                      containerDimensions={nodePreviewRef?.current?.getBoundingClientRect()}
                    />
                  </div>
                </div>
              ) : (
                preview
              )}
              {actionButton && <div className='absolute top-4 right-4'>{actionButton}</div>}
            </div>
            {renderContentPreview(isMobilePreview)}
            <StepEditorPreviewNavigator />
          </div>
        </div>
      )}
    </PreviewRenderer>
  );
};
